import React from 'react';
import TableHead from './table-head-row';
import TableBodyRow from './table-body-row';

const Topics = ({ pattern, router, topics, theme }) => {
    const handleClick = topicId => {
        router.push(`/topics/${topicId}`);
    }

    return (
        <>
            <TableHead pattern={pattern} />
            {topics.map((data, i) => (
                <TableBodyRow pattern={pattern} data={data} router={router} onClick={handleClick} key={i} theme={theme}/>
            ))}
        </>
    )
}

export default Topics;
